import {
  Box,
  Fade,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@material-ui/core'
import { Delete } from '@material-ui/icons'
import { isEmpty } from 'lodash'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { deletePaymentOptionStart } from '../../redux/modules/profile'

const NoPaymentMethods = () => (
  <Box alignItems="center" display="flex" justifyContent="center">
    <Grid
      alignContent="center"
      alignItems="center"
      container
      direction="column"
      justify="center"
      spacing={1}
    >
      <Grid>
        <img alt="" src="https://images.foodsby.com/conweb/creditcard-logo.png" />
      </Grid>
      <Grid>
        <Typography color="textPrimary" variant="h4">
          You don’t have any cards on file
        </Typography>
      </Grid>
      <Grid>
        <Typography color="textPrimary" variant="body1">
          You may add a new card the next time you checkout under Billing Information.
        </Typography>
      </Grid>
    </Grid>
  </Box>
)
const PaymentMethods = () => {
  const dispatchRedux = useDispatch()
  const creditCards = useSelector(state => state?.profile?.paymentOptions) ?? []
  const deleteCreditCardError = useSelector(state => state?.profile?.error)

  if (creditCards?.length > 0) {
    return (
      <>
        <Fade in={!isEmpty(creditCards)}>
          <Box>
            <Table>
              <TableBody>
                {creditCards.map(cc => (
                  <TableRow key={cc.ccProfileId}>
                    <TableCell>
                      <img alt="" src="https://images.foodsby.com/conweb/creditcard-icon.png" />
                    </TableCell>
                    <TableCell>
                      <span>**** </span>
                      {cc.lastFour}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => dispatchRedux(deletePaymentOptionStart(cc.ccProfileId))}
                      >
                        <Delete alt="Delete Card" color="textSecondary" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell align="center">
                    <span>Add cards at checkout</span>
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        </Fade>
        {deleteCreditCardError && (
          <Typography color="error" variant="body1">
            {deleteCreditCardError}
          </Typography>
        )}
      </>
    )
  } else if (creditCards?.length === 0) {
    return <NoPaymentMethods />
  } else return null
}

export default PaymentMethods
